/**
 * MainLayout Component
 * Main application layout with sidebar and header
 */

import React, { useState } from 'react';
import { Layout } from 'antd';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import type { HealthStatus } from '../../types';

const { Content } = Layout;

interface MainLayoutProps {
  systemStatus?: HealthStatus;
  onLogout?: () => void;
}

const MainLayout: React.FC<MainLayoutProps> = ({
  systemStatus = 'healthy',
  onLogout,
}) => {
  const [collapsed, setCollapsed] = useState(false);

  const handleCollapse = (isCollapsed: boolean) => {
    setCollapsed(isCollapsed);
  };

  return (
    <Layout style={{ minHeight: '100vh' }}>
      {/* Sidebar */}
      <Sidebar collapsed={collapsed} onCollapse={handleCollapse} />

      {/* Main Content Area */}
      <Layout
        style={{
          marginLeft: collapsed ? 80 : 220,
          transition: 'margin-left 0.2s',
        }}
      >
        {/* Header */}
        <Header
          collapsed={collapsed}
          systemStatus={systemStatus}
          onLogout={onLogout}
        />

        {/* Page Content */}
        <Content
          style={{
            marginTop: 64,
            padding: 24,
            minHeight: 'calc(100vh - 64px)',
            background: '#f0f2f5',
          }}
        >
          <div
            style={{
              maxWidth: 1600,
              margin: '0 auto',
            }}
          >
            <Outlet />
          </div>
        </Content>
      </Layout>
    </Layout>
  );
};

export default MainLayout;
